import { ApiBaseService, ApiV2Service } from './api.base.service';
import {LoRaNetworkServer, NetworkOperator} from '@/types';
import store from '@/store/store';

export class NetworkService {
  private apiV2: ApiBaseService;

  constructor() {
    this.apiV2 = ApiV2Service;
  }

  public async getNetworkOperators(): Promise<NetworkOperator[]> {
    return this.apiV2.get(`admin/network/operators`);
  }


  public async getOrganisationLnsList(): Promise<LoRaNetworkServer[]> {
    const organisationId = store.getters.activeOrganisationId;
    return this.apiV2.get(`organisation/${organisationId}/network/lns`);
  }

  public async getDeviceNetworkCredentials(deviceId: number): Promise<{ appEui?: string; appKey: string }> {
    const organisationId = store.getters.activeOrganisationId;
    return this.apiV2.get(`organisation/${organisationId}/devices/${deviceId}/credentials`);
  }

  public async getAlphanumericKey(): Promise<{ appEui?: string; appKey: string }> {
    const organisationId = store.getters.activeOrganisationId;
    return this.apiV2.get(`organisation/${organisationId}/credentials/generate`);
  }

  public async updateDeviceNetworkCredentials(deviceId: number, appKey: string): Promise<{ appKey: string }> {
    const organisationId = store.getters.activeOrganisationId;
    return this.apiV2.put(`organisation/${organisationId}/devices/${deviceId}/credentials`, { appKey });
  }
}

export default new NetworkService();
